import { Button } from '@neo/primitives/button'
import { Typography } from '@neo/primitives/typography'
import { Lock } from 'lucide-react'
import type { ReactNode } from 'react'
import { openBuddyEnterpriseRequest } from 'v2/shared/utils/buddy-enterprise-request'

interface RequestAccessCardProps {
  feature: string
  featureLabel?: string
  title?: ReactNode
  message: ReactNode
  ctaLabel?: string
  testId?: string
}

export const RequestAccessCard = ({
  featureLabel,
  title,
  message,
  ctaLabel = 'Request Access',
  testId = 'button-request-access',
}: RequestAccessCardProps) => {
  const handleRequestAccess = () => {
    openBuddyEnterpriseRequest({ source: 'voice-feature', featureLabel })
  }

  return (
    <div className="flex flex-1 items-center justify-center w-full h-full">
      <div className="flex flex-col items-center gap-3 text-center max-w-md px-6">
        <Lock className="w-6 h-6" />
        {title && <Typography variant="P/600">{title}</Typography>}
        <Typography variant="XS/400" className="text-secondary">
          {message}
        </Typography>
        <Button variant="outline" type="button" onClick={handleRequestAccess} data-testid={testId}>
          {ctaLabel}
        </Button>
      </div>
    </div>
  )
}
